import * as React from 'react';

const Clock16 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 16 16", width: 16, height: 16, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M8 0a8 8 0 1 0 0 16A8 8 0 0 0 8 0m0 1.5c3.584 0 6.5 2.916 6.5 6.5s-2.916 6.5-6.5 6.5A6.51 6.51 0 0 1 1.5 8c0-3.584 2.916-6.5 6.5-6.5m3.2 8.151a.75.75 0 1 1-.9 1.2L7.2 8.524a.5.5 0 0 1-.2-.4V4.25a.75.75 0 0 1 1.5 0v3.125a.5.5 0 0 0 .2.4z",
    clipRule: "evenodd"
  }
));
Clock16.Size = 16;
Clock16.Title = "Clock";

export { Clock16 as default };
